























































import { yandexMap, ymapMarker } from "vue-yandex-maps";
import TitleH2 from "@/components/common/TitleH2.vue";

export default {
  name: "Map",
  components: {
    yandexMap,
    ymapMarker,
    TitleH2,
  },
  props: {
    contacts: { type: Object, default: () => ({}) },
  },
};
